/*
 *
 * SelectCheckbox constants
 *
 */

export const LOAD_OPTIONS = 'claris-vnext/AdvancedForm/SelectCheckbox/LOAD_OPTIONS';
